import { ListErrorState } from './ListErrorState.js';

export function RouteNotFound() {
  return (
    <ListErrorState
      title="Not found"
      message="This link does not point to anything that exists. Check the address, or go back and pick it from the list."
    />
  );
}
